export const CONSTANTS = Object.freeze({
    STRIPE_PUBLIC_KEY: 'pk_live_51LznLwHWWZ1wz9tuxELU3GG9xdQVvUFkWEGyFmc5PFt8LvyvFHnp9xrgOwWDQN8vI55fScDByondc2HwABrp5Hsj00PlCeB5yd',
    APPLICATION_WEB_URL: 'https://tts.highku.xyz'
})